(function(){
if (!window.THREE || !document.getElementById('gl')) return;
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var canvas = document.getElementById('gl');
var renderer = new THREE.WebGLRenderer({canvas:canvas, antialias:true});
renderer.setPixelRatio(Math.min(window.devicePixelRatio||1, 2));
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.toneMapping = THREE.ACESFilmicToneMapping;
var scene = new THREE.Scene();
scene.background = new THREE.Color(0xE4E1D8);
var FOV = 30;
var camera = new THREE.PerspectiveCamera(FOV, 1, 0.1, 100);
camera.position.set(0, 0.6, 10);
camera.lookAt(0, 0, 0);
scene.add(new THREE.HemisphereLight(0xffffff, 0x8a877f, 0.8));
var key = new THREE.DirectionalLight(0xffffff, 1.3); key.position.set(-4, 5, 5); scene.add(key);
var rim = new THREE.PointLight(0x6E8BFF, 2.4, 20); rim.position.set(4, 1.5, -2); scene.add(rim);
var sc = document.createElement('canvas'); sc.width = sc.height = 128;
var sx = sc.getContext('2d'); var gr = sx.createRadialGradient(64,64,4,64,64,62);
gr.addColorStop(0,'rgba(0,0,0,0.32)'); gr.addColorStop(1,'rgba(0,0,0,0)'); sx.fillStyle = gr; sx.fillRect(0,0,128,128);
var shadowTex = new THREE.CanvasTexture(sc);
function shadow(w,d,y){ var m = new THREE.Mesh(new THREE.PlaneGeometry(w,d), new THREE.MeshBasicMaterial({map:shadowTex, transparent:true, depthWrite:false})); m.rotation.x = -Math.PI/2; m.position.y = y; return m; }
function item(group, radius){ group.userData.radius = radius; group.visible = false; scene.add(group); return group; }
var lights = new THREE.Group();
var white = new THREE.MeshStandardMaterial({color:0xF4F4F2, roughness:0.35});
function puck(){
var g = new THREE.Group();
var body = new THREE.Mesh(new THREE.CylinderGeometry(1, 1, 0.32, 96), white); body.rotation.x = Math.PI/2; g.add(body);
var lip = new THREE.Mesh(new THREE.TorusGeometry(0.97, 0.06, 24, 96), white); lip.position.z = 0.16; g.add(lip);
var lens = new THREE.MeshStandardMaterial({color:0xFFFFFF, roughness:0.6, emissive:0xFFC98A, emissiveIntensity:0});
var face = new THREE.Mesh(new THREE.CircleGeometry(0.86, 96), lens); face.position.z = 0.165; g.add(face);
var eye = new THREE.Mesh(new THREE.SphereGeometry(0.06, 24, 24), new THREE.MeshStandardMaterial({color:0x222222, roughness:0.2})); eye.position.set(0,-0.7,0.17); g.add(eye);
g.userData.lens = lens; return g;
}
var l1 = puck(); l1.position.set(-0.8, 0.1, 0.2); l1.rotation.y = 0.35; lights.add(l1);
var l2 = puck(); l2.position.set(0.85, -0.05, -0.4); l2.rotation.y = -0.25; lights.add(l2);
var glow = new THREE.PointLight(0xFFC98A, 0, 6); glow.position.set(-0.8, 0.1, 1.4); lights.add(glow);
lights.add(shadow(4.4, 1.6, -1.3));
item(lights, 2.2);
var warm = new THREE.Group(), warmInner = new THREE.Group(); warmInner.position.y = -1.0; warm.add(warmInner);
var black = new THREE.MeshStandardMaterial({color:0x111111, roughness:0.2, metalness:0.3});
warmInner.add(new THREE.Mesh(new THREE.CylinderGeometry(1.5, 1.55, 0.2, 96), black));
var ring = new THREE.Mesh(new THREE.TorusGeometry(1.26, 0.02, 12, 128), new THREE.MeshStandardMaterial({color:0xFF5A1F, emissive:0xFF5A1F, emissiveIntensity:0}));
ring.rotation.x = Math.PI/2; ring.position.y = 0.105; warmInner.add(ring);
var dot = new THREE.Mesh(new THREE.CylinderGeometry(0.07,0.07,0.02,24), new THREE.MeshStandardMaterial({color:0xffffff, emissive:0xffffff, emissiveIntensity:0.5}));
dot.position.set(1.1, 0.11, 0.55); warmInner.add(dot);
var prof = []; [[0,0],[0.72,0],[0.78,0.05],[0.82,0.3],[0.84,1.5],[0.86,1.6],[0.8,1.6],[0.76,1.5],[0.74,0.3],[0,0.28]].forEach(function(p){ prof.push(new THREE.Vector2(p[0],p[1])); });
var ceramic = new THREE.MeshStandardMaterial({color:0xFAFAF7, roughness:0.3});
var mug = new THREE.Mesh(new THREE.LatheGeometry(prof, 96), ceramic); mug.position.y = 0.1; warmInner.add(mug);
var handle = new THREE.Mesh(new THREE.TorusGeometry(0.36, 0.08, 24, 64, Math.PI*1.15), ceramic);
handle.rotation.z = Math.PI/2 - 0.3; handle.position.set(-0.92, 0.95, 0); warmInner.add(handle);
var coffee = new THREE.Mesh(new THREE.CircleGeometry(0.75, 64), new THREE.MeshStandardMaterial({color:0x2A160B, roughness:0.15}));
coffee.rotation.x = -Math.PI/2; coffee.position.y = 1.52; warmInner.add(coffee);
var N = 80, steamGeo = new THREE.BufferGeometry(), sp = new Float32Array(N*3), seeds = [];
for (var i=0;i<N;i++) seeds.push(Math.random());
steamGeo.setAttribute('position', new THREE.BufferAttribute(sp, 3));
var steamMat = new THREE.PointsMaterial({color:0xffffff, size:0.08, transparent:true, opacity:0, depthWrite:false});
warmInner.add(new THREE.Points(steamGeo, steamMat));
warmInner.add(shadow(5, 2, -0.12));
item(warm, 2.4);
var brush = new THREE.Group();
var clearMat = new THREE.MeshStandardMaterial({color:0xF7FBFF, roughness:0.05, metalness:0.0, transparent:true, opacity:0.42, side:THREE.DoubleSide});
var rimMat = new THREE.MeshStandardMaterial({color:0xFFFFFF, roughness:0.1, transparent:true, opacity:0.75});
var kibbleGroups = [], waters = [];
function catBowl(withFood){
var g = new THREE.Group();
var prof = []; [[0,0],[0.55,0],[0.9,0.12],[1.1,0.45],[1.14,0.62],[1.08,0.62],[1.04,0.46],[0.86,0.18],[0.5,0.08],[0,0.08]].forEach(function(p){ prof.push(new THREE.Vector2(p[0],p[1])); });
var bowl = new THREE.Mesh(new THREE.LatheGeometry(prof, 96), clearMat); g.add(bowl);
var rim = new THREE.Mesh(new THREE.TorusGeometry(1.12, 0.035, 12, 96), rimMat); rim.rotation.x = Math.PI/2; rim.position.y = 0.62; g.add(rim);
[-1,1].forEach(function(sd){ var ear = new THREE.Mesh(new THREE.ConeGeometry(0.28, 0.42, 3), clearMat); ear.position.set(sd*0.62, 0.86, -0.9); ear.rotation.set(-0.35, 0, sd*-0.25); g.add(ear); });
if (withFood){
var kg = new THREE.Group(), km = new THREE.MeshStandardMaterial({color:0x9A5B2E, roughness:0.7});
for (var i=0;i<46;i++){ var k = new THREE.Mesh(new THREE.SphereGeometry(0.1, 12, 10), km); var ang = Math.random()*Math.PI*2, rad = Math.random()*0.75; k.position.set(Math.cos(ang)*rad, 0.18 + Math.random()*0.18, Math.sin(ang)*rad); k.scale.set(1, 0.7, 1); kg.add(k); }
g.add(kg); kibbleGroups.push(kg);
} else {
var w = new THREE.Mesh(new THREE.CircleGeometry(0.98, 64), new THREE.MeshStandardMaterial({color:0x9FD8F0, roughness:0.05, transparent:true, opacity:0.0}));
w.rotation.x = -Math.PI/2; w.position.y = 0.4; g.add(w); waters.push(w);
}
g.rotation.x = 0.26;
var holder = new THREE.Group(); holder.add(g); g.position.y = 0.9;
var leg = new THREE.Mesh(new THREE.CylinderGeometry(0.42, 0.62, 0.9, 48, 1, true), clearMat); leg.position.y = 0.45; holder.add(leg);
var foot = new THREE.Mesh(new THREE.CylinderGeometry(0.66, 0.66, 0.05, 48), rimMat); foot.position.y = 0.02; holder.add(foot);
return holder;
}
var c1 = catBowl(true); c1.position.set(-1.25, -0.9, 0); brush.add(c1);
var c2 = catBowl(false); c2.position.set(1.25, -0.9, 0); brush.add(c2);
var trays = [];
brush.add(shadow(5.6, 1.8, -0.88));
item(brush, 2.5);
var items = [lights, warm, brush];
var colors = [new THREE.Color(window.SXC||'#6E8BFF'), new THREE.Color(window.SXC||'#FF5A1F'), new THREE.Color(window.SXC||'#C9B6FF')];
var off = new THREE.Color(0xD6D3C9), idle = new THREE.Color(0xE4E1D8);
var mi = window.SXF || 0;
items.forEach(function(g,i){ g.visible = i === mi; });
var g = items[mi];
var aspect = 1;
function resize(){ var w = canvas.clientWidth, h = canvas.clientHeight; if (!w || !h) return; renderer.setSize(w, h, false); aspect = w/h; camera.aspect = aspect; camera.updateProjectionMatrix(); }
window.addEventListener('resize', resize); resize();
function fitDistance(r){ var v = THREE.MathUtils.degToRad(FOV)/2, hz = Math.atan(Math.tan(v)*aspect); return Math.max(r/Math.sin(v), r/Math.sin(hz))*1.08; }
var cur = {on:0, z:10}, clock = new THREE.Clock(), ptr = {x:0,y:0,tx:0,ty:0};
window.addEventListener('pointermove', function(e){ if (e.pointerType !== 'mouse') return; ptr.tx = e.clientX/window.innerWidth*2-1; ptr.ty = e.clientY/window.innerHeight*2-1; }, {passive:true});
function lerp(a,b,k){ return a + (b-a)*k; }
function frame(){
var dt = Math.min(clock.getDelta(), 0.05), time = clock.elapsedTime, s = SX.step, t = SX.t, k = reduce ? 1 : 1 - Math.pow(0.001, dt);
var on = s === 2 ? 1 : (s === 0 ? 0.25 : 0);
cur.on = lerp(cur.on, on, k); cur.z = lerp(cur.z, fitDistance(g.userData.radius), k);
camera.position.set(0, 0.5, cur.z); camera.lookAt(0, 0, 0);
ptr.x = lerp(ptr.x, reduce?0:ptr.tx, k*0.5); ptr.y = lerp(ptr.y, reduce?0:ptr.ty, k*0.5);
var base = s === 0 ? time*0.3 : (-0.5 + t*0.9);
g.rotation.y = lerp(g.rotation.y, base + ptr.x*0.35, reduce ? 1 : k*0.8);
g.rotation.x = 0.18 + ptr.y*0.12;
g.position.y = reduce ? 0 : Math.sin(time)*0.05;
l1.userData.lens.emissiveIntensity = mi===0 ? 0.05 + cur.on*2.2 : 0;
l2.userData.lens.emissiveIntensity = mi===0 ? 0.05 + cur.on*1.6 : 0;
glow.intensity = mi===0 ? cur.on*2.5 : 0;
ring.material.emissiveIntensity = mi===1 ? cur.on*1.8 : 0;
steamMat.opacity = mi===1 ? cur.on*0.6 : 0;
if (mi===1 && !reduce){ var a = steamGeo.attributes.position.array;
for (var i=0;i<N;i++){ var life = (time*0.35 + seeds[i]) % 1; a[i*3] = Math.sin(seeds[i]*20 + life*6)*0.22*(0.3+life) + (seeds[i]-0.5)*0.45; a[i*3+1] = 1.6 + life*1.4; a[i*3+2] = Math.cos(seeds[i]*13 + life*5)*0.18*(0.3+life); }
steamGeo.attributes.position.needsUpdate = true; }
if (mi===2){ kibbleGroups.forEach(function(kg){ kg.scale.setScalar(0.001 + cur.on*0.999); kg.visible = cur.on > 0.02; }); waters.forEach(function(w){ w.material.opacity = cur.on*0.6; }); }
rim.color.copy(colors[mi]);
var bg = s === 0 ? idle : (s === 2 ? colors[mi] : off);
scene.background.lerp(bg, reduce ? 1 : 1 - Math.pow(0.02, dt));
renderer.render(scene, camera);
requestAnimationFrame(frame);
}
requestAnimationFrame(frame);
})();
